import Input from '@/components/Input.jsx';
import KeyHandler from '@/components/KeyHandler.jsx';
import ModalV2 from '@/components/ModalV2.jsx';
import useUser from '@/hooks/useUser.js';
import sendToast from '@/lib/sendToast.js';
import { postPlatformIssue } from '@/redux/actions/gravityActions.js';
import { setModalState } from '@/redux/actions/uiActions/modalActions.js';
import waitForSyncReady from '@/redux/actions/waitForSyncReady.js';
import memoizeSelector from '@/redux/lib/memoizeSelector';
import { modal } from '@/redux/selectors/uiSelectors';
import { userSelectedCompany } from '@/redux/selectors/userSelectors.js';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors.js';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const PlatformIssueModal = () => {
  const inputRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');
  const tutorialSlug = useSelector((state) => workflowScreenSelectors.activeWorkflowMetadata(state)?.tutorialSlug);
  const modalState = useSelector(memoizeSelector('modal:reportPlatformIssue', (state) => modal(state, 'reportPlatformIssue')));
  const currentCompany = useSelector(userSelectedCompany);
  const user = useUser();

  const show = modalState?.open;
  const companyName = currentCompany?.isPersonal ? 'Personal Account' : currentCompany?.name;
  const userName = user?.jwt?.name;
  const userEmail = user?.jwt?.email;

  const handleClose = () => {
    setIsSaving(false);
    setMessage('');
    setModalState('reportPlatformIssue', { open: false });
  };

  const handleReportIssue = async () => {
    setIsSaving(true);
    await waitForSyncReady();
    await postPlatformIssue({ companyName, userName, userEmail, message, tutorialSlug });
    setIsSaving(false);
    handleClose();
    sendToast({ message: 'Your issue has been submitted! We will get back to you soon.', type: 'success' });
  };

  const keyMap = {
    Enter: handleReportIssue
  };

  const submitIsDisabled = !message;

  const actions = [{ children: 'Report Issue', onClick: handleReportIssue, className: 'primary', disabled: submitIsDisabled, loading: isSaving }];

  return (
    <ModalV2
      maxWidth={'600px'} //
      className={'report-platform-issue-modal'}
      show={show}
      onHide={handleClose}
      title={`Report Issue`}
      description={`Please describe the issue you're experiencing. We'll get back to you as soon as possible.`}
      autoFocusRef={inputRef}
      actions={actions}>
      <Input ref={inputRef} value={message} onChange={(e) => setMessage(e.target.value)} placeholder={'Describe the issue...'} type={'textarea'} rows={10} />
      <KeyHandler keyMap={keyMap} global={true} preventDefault={true} stopPropagation={true} />
    </ModalV2>
  );
};

export default PlatformIssueModal;
